
let currentTarget = "";
let filteredCountries = [];

// Fonction pour charger les données des pays
function loadCountriesData() {
    return axios
        .get(route("payss-get-all"))
        .then((response) => {
            // Store countries data in une variable globale
            window.countries = response.data;
            filteredCountries = [...window.countries];
            return response.data;
        })
        .catch((error) => {
            console.error("Erreur lors de la récupération des pays :", error);
            throw error;
        });
}

// Initialiser la liste des pays
function initCountriesList() {
    if ($("#countryModal").length === 0) return;

    const countriesList = document.getElementById("countriesList");
    if (!countriesList) return;

    countriesList.innerHTML = "";

    filteredCountries.forEach((country) => {
        const flag = country.flag_icon ?? "xx"; // valeur par défaut
        const indicatif = country.indicatif_tel ?? "000";

        const countryItem = document.createElement("button");
        countryItem.className = "country-item";

        countryItem.innerHTML = `
            <img src="https://flagcdn.com/w20/${flag}.png" 
                 alt="${country.label}" 
                 class="country-flag"
                 onerror="this.style.display='none'">
            <div class="country-info">
                <span class="country-name">${country.label}</span>
                <span class="country-code">+${indicatif}</span>
            </div>
        `;

        countryItem.addEventListener("click", () => selectCountry(country));
        countriesList.appendChild(countryItem);
    });
}

// Sélectionner un pays
function selectCountry(country) {
    try {
        const indicatif_tel = country.indicatif_tel ?? "000";
        const flag = country.flag_icon ?? "xx";

        $(".span_country_flag").attr("src", `https://flagcdn.com/w20/${flag}.png`);
        $(".span_country_flag").attr("alt", country.label ?? "");
        $(".span_country_indicatif").text("+" + (indicatif_tel ?? "000"));
        $("#indicatif_tel").val(indicatif_tel);
        $("#country").val(flag.toString().toUpperCase());

    } catch (error) {
        console.error("Erreur lors de la mise à jour du sélecteur de pays :", error);
    }

    // Fermer le modal si instance existe
    const modalElement = document.getElementById("countryModal");
    const modal = bootstrap.Modal.getInstance(modalElement);
    if (modal) modal.hide();
}

// Recherche de pays
function filterCountries(searchTerm) {
    if ($("#countryModal").length === 0) return;
    if (!window.countries) return;

    filteredCountries = window.countries.filter((country) => {
        const label = (country.label ?? "").toLowerCase();
        const indicatif = (country.indicatif_tel ?? "").toString().toLowerCase();
        const search = searchTerm.toLowerCase();

        return (
            label.includes(search) ||
            indicatif.includes(search)
        );
    });

    initCountriesList();
}

// Initialiser le modal et charger les données si nécessaire
function initCountryModal() {
    try {
        if ($("#countryModal").length === 0) return;

        if (!window.countries) {
            loadCountriesData()
                .then(() => initCountriesList())
                .catch((error) => {
                    console.error("Impossible de charger les données des pays:", error);
                });
        } else {
            filteredCountries = [...window.countries];
            initCountriesList();
        }
    } catch (error) {
        console.log("Erreur initialisation des données du modal country-select")
    }
}

// Event listeners
document.addEventListener("DOMContentLoaded", function () {
    if ($("#countryModal").length > 0) {
        initCountryModal();

        // Gérer l'ouverture du modal
        document.querySelectorAll(".country-selector").forEach((selector) => {
            selector.addEventListener("click", function () {
                currentTarget = this.getAttribute("data-target");
                const searchInput = document.getElementById("countrySearch");
                if (searchInput) searchInput.value = "";

                if (window.countries) {
                    filteredCountries = [...window.countries];
                    initCountriesList();
                }
            });
        });

        // Gérer la recherche
        const countrySearch = document.getElementById("countrySearch");
        if (countrySearch) {
            countrySearch.addEventListener("input", function (e) {
                filterCountries(e.target.value);
            });
        }

        // Réinitialiser à la fermeture du modal
        const countryModal = document.getElementById("countryModal");
        if (countryModal) {
            countryModal.addEventListener("hidden.bs.modal", function () {
                const searchInput = document.getElementById("countrySearch");
                if (searchInput) searchInput.value = "";
                if (window.countries) {
                    filteredCountries = [...window.countries];
                    initCountriesList();
                }
            });
        }
    }
});
